export const manifest = {
  screens: {
    scr_zcki0l: { name: "Home", route: "/" },
  },
}
